import type i18n from "../i18n";

export const ageOptions = [
  {
    value: "ageGroup-1",
    text: "< 18",
    // category: "age",
    color: "blue-600",
    lowerBound: 0,
    upperBound: 17,
  } as const,
  {
    value: "ageGroup-2",
    text: "18 - 24",
    // category: "age",
    color: "blue-600",
    lowerBound: 18,
    upperBound: 24,
  } as const,
  {
    value: "ageGroup-3",
    text: "25 - 34",
    // category: "age",
    color: "blue-600",
    lowerBound: 25,
    upperBound: 34,
  } as const,
  {
    value: "ageGroup-4",
    text: "35 - 44",
    // category: "age",
    color: "blue-600",
    lowerBound: 35,
    upperBound: 44,
  } as const,
  {
    value: "ageGroup-5",
    text: "45 - 54",
    // category: "age",
    color: "blue-600",
    lowerBound: 45,
    upperBound: 54,
  } as const,
  {
    value: "ageGroup-6",
    text: "55 - 64",
    // category: "age",
    color: "blue-600",
    lowerBound: 55,
    upperBound: 64,
  } as const,
  {
    value: "ageGroup-7",
    text: "65+",
    // category: "age",
    color: "blue-600",
    lowerBound: 65,
    upperBound: 100,
  } as const,
  // {
  //   value: "noInformation",
  //   text: i18n?.t("global:noInformation"),
  //   color: "blue-600",
  // } as const,
];

export const genderOptions = ({ t }: typeof i18n) => [
  {
    value: "female",
    text: t("global:female"),
    // category: "gender",
    color: "orange-500",
  } as const,
  {
    value: "male",
    text: t("global:male"),

    // category: "gender",
    color: "orange-500",
  } as const,

  {
    value: "diverse",
    text: t("global:diverse"),
    // category: "gender",
    color: "orange-500",
  } as const,
  {
    value: "preferNotToSay",
    text: t("global:preferNotToSay"),
    color: "orange-500",
  } as const,
  // {
  //   value: "noInformation",
  //   text: t("global:noInformation"),
  //   color: "blue-600",
  // } as const,
];

export const sentimentOptions = [
  {
    value: "sentiment-5",
    text: "Sehr positiv",
    // category: "age",
    color: "blue-600",
    lowerBound: 0.700001,
    upperBound: 1,
  } as const,
  {
    value: "sentiment-4",
    text: "Positiv",
    // category: "age",
    color: "blue-600",
    lowerBound: 0.300001,
    upperBound: 0.7,
  } as const,
  {
    value: "sentiment-3",
    text: "Neutral",
    // category: "age",
    color: "blue-600",
    lowerBound: -0.300001,
    upperBound: 0.3,
  } as const,
  {
    value: "sentiment-2",
    text: "Negativ",
    // category: "age",
    color: "blue-600",
    lowerBound: -0.700001,
    upperBound: -0.3,
  } as const,
  {
    value: "sentiment-1",
    text: "Sehr negativ",
    // category: "age",
    color: "blue-600",
    lowerBound: -1,
    upperBound: -0.7,
  } as const,
];
